export const STRIKE_PRICE_DECIMALS = 8
export const ANNUALIZED_VOLATILITY_DECIMALS = 18

export const REFETCH_TIMEOUT = 10000
